import Axios from '@/utils/axios'
const URL = '/atendimento-hai'

export default {
  validateToken: token => {
    return Axios.post(`${URL}/validate-token`, { token })
  }
}
